import React from "react";
import type { CheckboxGroupState } from "react-stately";

export const CheckboxGroupContext = React.createContext<CheckboxGroupState>(
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  null!
);
